import React, { useContext, useEffect, useState } from "react";
import { Layout, theme } from "antd";
import CustomHeader from "./CustomHeader";
import CustomFooter from "./CustomFooter";
import { useNavigate, useParams } from "react-router";
import AppContext from "../../store/app.context";

const { Content } = Layout;

function Main({
	children,
	showFooter = true,
	fullHeight = true,
}: {
	children?: React.ReactNode;
	showFooter?: boolean;
	fullHeight?: boolean;
}) {
	const context = useContext(AppContext);
	const { teamId } = useParams();
	const navigate = useNavigate();
	const [collapsed, setCollapsed] = useState(false);
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [_, setQuery] = useState("");

	const {
		token: { colorBgLayout },
	} = theme.useToken();

	useEffect(() => {
		// if teamId is "undefined"
		if (teamId === "undefined") {
			// set the teamId to defaultTeamId
			const defaultTeamId =
				context.user.teams && context.user.teams.length > 0 ? context.user.teams[0]._id : undefined;

			const selectedTeamId = context.team && context.team._id ? context.team._id : undefined;

			if (selectedTeamId) {
				navigate(`/${selectedTeamId}/dashboard`);
			} else if (defaultTeamId) {
				navigate(`/${defaultTeamId}/dashboard`);
			} else {
				navigate(`/settings`);
			}
		}
	}, [teamId]);

	return (
		<div
			style={{
				background: colorBgLayout,
			}}>
			{/* <CustomSider collapsed={collapsed} setCollapsed={setCollapsed} query={query} /> */}
			<Layout
				style={{
					margin: "0 auto",
				}}>
				<CustomHeader
					onSearch={(value: any) => setQuery(value)}
					collapsed={collapsed}
					setCollapsed={setCollapsed}
				/>
				<Content
					style={{
						margin: "24px 0",
						padding: "0 24px",
						overflow: "initial",
						minHeight: fullHeight ? "calc(100svh - 94px)" : "100%",
					}}>
					<div>{children}</div>
				</Content>
				{showFooter && <CustomFooter />}
			</Layout>
		</div>
	);
}

export default Main;
